import { render } from "./InlineEdit.vue?vue&type=template&id=60e756de"
import script from "./InlineEdit.vue?vue&type=script&lang=js"
export * from "./InlineEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjektetRentaCar\\albertinew-xerxe\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QBtn});
